/**
 * Display code for a language. Kyrgyz is stored and routed as the ISO 639-1
 * code `ky`, but every user-facing label prints it as "KG"; anything else is
 * shown upper-cased ("ru" → "RU"). Case-insensitive, because seller profiles
 * can carry legacy mixed-case values ("KY", "ky").
 */
export function languageCode(code: string): string {
  const normalized = code.trim().toLowerCase();
  return normalized === "ky" ? "KG" : normalized.toUpperCase();
}
